import React, {useState, useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {InputLabel,FormControl,Select as MaterialSelect  ,Box,  
  TextareaAutosize ,TextField,RadioGroup,FormControlLabel,Radio,
  TableRow, TableCell, TableContainer,Table, TableHead, TableBody
  } from '@material-ui/core';
import axios from 'axios';
import qs from 'qs';
import {toast} from "react-toastify";
import { useHistory } from "react-router-dom";
import Relojes from './Relojes4'
import Modal from '../Generales/Modal';
import moment from 'moment';
import {llamaApiCargaToken,ErrorGeneral } from '../funciones/ClienteAxios';
const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
        width: '20ch',
      }, 
      formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
      },
      selectEmpty: {
        marginTop: theme.spacing(2),
      },
      Textnumero: {
        width: 5+"px",
      },
      formControlFull: {
        //margin: theme.spacing(1),
        //minWidth: 120,
        width:5+"rem"
      },
    },  
    row: {
      width: '100%',         
    },
    tablaContainer: {      
      //maxHeight: window.innerHeight-480,    
      minHeight: 180,      
    },
  }));

const ModalCapturaUsuarios = ({modalAbierto, setModalAbierto, titulo, bitacora,  Bucle, finicio,listUsu, setListUsu}) => {
  let history = useHistory();
  const classes = useStyles();
  const source = axios.CancelToken.source();   
  const colorFuente = "#51ad32"   
  const limitNumber=6 
  const anchoLabel ="32rem"
  const anchoTxtLbl ="25rem"
  const idusu= localStorage.getItem('UsuId'); 
  const [espera,setEspera]= useState(false);
  const [mensaje, setMensaje] = useState('');
  const [tipoAdvertencia, setTipoAdvertencia] = useState('success');
  const [aviso, setAviso] = useState(false);
  const [listTotUsu, setListTotUsu] = useState([]);
  const [usuarios, setUsuarios] = useState({estacion1:"1", tp0Est1:0, tp1Est1:0, tp2Est1:0, tp3Est1:0, tp4Est1:0,
     estacion2:"2", tp0Est2:0, tp1Est2:0, tp2Est2:0, tp3Est2:0, tp4Est2:0,
     estacion3:"3A", tp0Est3:0, tp1Est3:0, tp2Est3:0, tp3Est3:0, tp4Est3:0,
     estacion4:"4", tp0Est4:0, tp1Est4:0, tp2Est4:0, tp3Est4:0, tp4Est4:0,
     estacion5:"5", tp0Est5:0, tp1Est5:0, tp2Est5:0, tp3Est5:0, tp4Est5:0,
     estacion6:"6", tp0Est6:0, tp1Est6:0, tp2Est6:0, tp3Est6:0, tp4Est6:0,
     estacion7:"7", tp0Est7:0, tp1Est7:0, tp2Est7:0, tp3Est7:0, tp4Est7:0,
   });
  const [costos, setCostos] = useState({'CostoUser':0.0, 'CostoEstu':0.0, 'Estudiante':0,
      'TrnsEstudiante':0, 'TrnsLrLv':0, 'TrnsBusOp1':0, 'TrnsBusOp2':0,
      'Tarjeta':0, 'Sanitario':0,})
  const {CostoUser, CostoEstu, Estudiante, TrnsEstudiante, TrnsLrLv,
      TrnsBusOp1, TrnsBusOp2, Tarjeta, Sanitario, } = costos
  const [totUsu, setTotUsu] = useState({ tp0Tot:0, tp1Tot:0, tp2Tot:0, tp3Tot:0, tp4Tot:0, tp5Tot:0, tp6Tot:0, tp7Tot:0,})
 
  useEffect(()=>{ 
 
    getListTotUsu()  
    getEstacionExtra()

    return ()=> {
      source.cancel();
    }  
    
  },[]);

  useEffect(()=>{ 
    let auxArr =[], nvoVal1=0, nvoVal2=0, nvoVal3=0
    let nvoVal4=0, nvoVal5=0, nvoVal6=0, nvoVal7=0     
  
    if (listTotUsu.length!==0) 
    { listTotUsu.forEach((registro)=>{           
        nvoVal1 += sumTot(usuarios[`tp0Est${registro.estacion}`])    
        nvoVal2 += sumTot(usuarios[`tp1Est${registro.estacion}`])   
        nvoVal3 += sumTot(usuarios[`tp2Est${registro.estacion}`])    
        nvoVal4 += sumTot(usuarios[`tp3Est${registro.estacion}`])   
        nvoVal5 += sumTot(usuarios[`tp4Est${registro.estacion}`])    
        nvoVal6 += sumTot(usuarios[`tp5Est${registro.estacion}`])   
        nvoVal7 += sumTot(usuarios[`tp6Est${registro.estacion}`])   
      })
    } 
      
    auxArr= {tp0Tot:nvoVal1, tp1Tot:nvoVal2, tp2Tot:nvoVal3, tp3Tot:nvoVal4, tp4Tot:nvoVal5,
              tp5Tot:nvoVal6, tp6Tot:nvoVal7 }               
    setTotUsu(auxArr)
    
  },[usuarios]);  

  const sumTot=(auxVal)=>{
    const val1= parseInt(auxVal)              
    if (typeof val1 ==="number" && !isNaN(val1) ) {
      return val1 
    }
    return 0       
  }

  const  valInpNumber=(campo)=>{
    const valor=parseInt(campo)      
    let respuesta= false
    if (typeof valor ==="number" && !isNaN(valor) 
      && (campo!== "" || campo!== " ") ) {
      
      respuesta=true
    }
    return respuesta
  }
 
  const valListUsu=()=>{
    let respuesta = true
    
    if (respuesta && !valInpNumber(usuarios[`tp0Est1`]) ) {
      respuesta = false
    }    
    if (respuesta && !valInpNumber(usuarios[`tp1Est1`]) ) {
      respuesta = false
    }
    if (respuesta && !valInpNumber(usuarios[`tp2Est1`]) ) {
      respuesta = false
    }
    if (respuesta && !valInpNumber(usuarios[`tp3Est1`]) ) {
      respuesta = false
    }
    if (respuesta && !valInpNumber(usuarios[`tp4Est1`]) ) {
      respuesta = false
    }
    if (respuesta && !valInpNumber(usuarios[`tp0Est2`]) ) {
      respuesta = false
    }
    if (respuesta && !valInpNumber(usuarios[`tp1Est2`]) ) {
      respuesta = false
    }
    if (respuesta && !valInpNumber(usuarios[`tp2Est2`]) ) {
      respuesta = false
    }    
    if (respuesta && !valInpNumber(usuarios[`tp3Est2`]) ) {
      respuesta = false
    }    
    if (respuesta && !valInpNumber(usuarios[`tp4Est2`]) ) {
      respuesta = false
    }        
    if (respuesta && !valInpNumber(usuarios[`tp0Est3`]) ) {
      respuesta = false
    }
    if (respuesta && !valInpNumber(usuarios[`tp1Est3`]) ) {
      respuesta = false
    }
    if (respuesta && !valInpNumber(usuarios[`tp2Est3`]) ) {
      respuesta = false
    }    
    if (respuesta && !valInpNumber(usuarios[`tp3Est3`]) ) {
      respuesta = false
    }    
    if (respuesta && !valInpNumber(usuarios[`tp4Est3`]) ) {
      respuesta = false
    }    
    if (!respuesta) {
      mostrarAlertas("Debe llenar los Campos de Usuarios con un valor de 0 o mayor")
    }        
    return respuesta
  }

  const valListUsu2 =() =>{
    let  respuesta=true
    listTotUsu.forEach((registro)=>{
      for (let index = 0; index < 5; index++) {        
        if (respuesta && !valInpNumber(usuarios[`tp${index}Est${registro.estacion}`]) ) {
          respuesta=false
        }
      }     
    })
    if (!respuesta) {
      mostrarAlertas("Debe llenar los Campos de Usuarios con un valor de 0 o mayor")
    }  
    return respuesta 
  }

  const getEstacionExtra=( )=>{   
    const auxF=moment(finicio).format("YYYY-MM-DD")
    const auxU = `/bitacora/usuario/v1/estacion/extra`;                   
    const dataInfo = qs.stringify({                        
      'usuario':idusu,
      'fecha':`${auxF}T00:00:00`,            
      'idDispositivo':'987gyubjhkkjh'
    });      
    function respuesta(aux) {
      if (aux) 
      {                                                                         
        setCostos({...costos,'CostoUser':aux[0].CobroCosto, 'CostoEstu':aux[0].EstudCosto, 
          'Estudiante':aux[0].Estud, 'TrnsEstudiante':aux[0].Trs_Estud, 'TrnsLrLv':aux[0].Trs_LrLv, 
          'TrnsBusOp1':aux[0].Trs_BusOp1, 'TrnsBusOp2':aux[0].Trs_BusOp2,
          'Tarjeta':aux[0].Tarjeta, 'Sanitario':aux[0].Sanit,})
        
      }               
    }
    llamaApiCargaToken(dataInfo, auxU,respuesta,ErrorGeneral,setEspera,history,source);                 
  }

  const getListTotUsu=( )=>{   
    //const auxF=moment(finicio).format("YYYY-MM-DD")
    const fec = moment(finicio).format("YYYY-MM-DD");                
    const auxU = `/bitacora/usuario/v1/estacion`;               
    const dataInfo = qs.stringify({                        
      'usuario':idusu,
      'fecha':`${fec}T00:00:00`,            
      'idDispositivo':'987gyubjhkkjh'
    });      
    function respuesta(aux) {
      if (aux) 
      {                                                                         
        setListTotUsu(aux) 
      /*   setUsuarios({...usuarios, estacion1:aux[0].nom, tp0Est1:aux[0].tp0, 
          tp1Est1:aux[0].tp1, tp2Est1:aux[0].tp2, tp3Est1:aux[0].tp3, tp4Est1:aux[0].tp4,          
        }) */
        let nvoArr=[]
        aux.forEach((regis, index)=>{
          const indice=index+1
          nvoArr={...nvoArr, [`estacion${indice}`]: regis.nom, [`tp0Est${indice}`]: regis.tp0,
            [`tp1Est${indice}`]: regis.tp1,
            [`tp2Est${indice}`]: regis.tp2, [`tp3Est${indice}`]: regis.tp3, [`tp4Est${indice}`]: regis.tp4,
           }
        })
        setUsuarios(nvoArr)
        //console.log(nvoArr);
        
      }               
    }
    llamaApiCargaToken(dataInfo, auxU,respuesta,ErrorGeneral,setEspera,history,source);                 
  }

  const registrarCierre=(auxHFin)=>{
            
    const auxU = `/bitacora/usuario/v1/estacion/extra/edit`;               
    const dataInfo = qs.stringify({                    
      'Usuario':idusu,
      'Fecha':`${auxHFin}T00:00:00`,
      'CostoUser':CostoUser,
      'CostoEstu':CostoEstu,
      'Estudiante':Estudiante,
      'TrnsEstudiante':TrnsEstudiante,
      'TrnsLrLv':TrnsLrLv,
      'TrnsBusOp1':TrnsBusOp1,
      'TrnsBusOp2':TrnsBusOp2,
      'Tarjeta':Tarjeta,
      'Sanitario':Sanitario,
      'idDispositivo':'987gyubjhkkjh'
    });      
    function respuesta(aux) {
      if (aux.keyId==1) 
      {                                                                 
        //console.log(aux);
        const mensaje="Se registro correctamente los costos "
        toast.success(mensaje, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setModalAbierto(false)
        setTipoAdvertencia("success")      
        setMensaje(mensaje);
        setAviso(true)          
                 
      }               
    }
    llamaApiCargaToken(dataInfo, auxU,respuesta,ErrorGeneral,setEspera,history,source);                 
  }

  const setEditUsu =( arrUsu)=>{    
    //const auxH=new Date()
    const hoy=moment(finicio).format("YYYY-MM-DD")
    const auxU = `/bitacora/usuario/v1/estacion/edit`;               
    const dataInfo = qs.stringify({                        
      'Usuario':idusu,
      'Fecha': `${hoy}T00:00:00`,
      'Terminal':Bucle,
      'Cambio':JSON.stringify(arrUsu),
      'idDispositivo':'987gyubjhkkjh'
    });      
    function respuesta(aux) {
      if (aux.length!==0) 
      {                                                                 
        //console.log(aux);
        const mensaje="Se edito correctamente los Usuarios "
        toast.success(mensaje, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        
          setListUsu({...listUsu, Usuarios:aux.keyTp0, Exentos:aux.keyTpExe})          
        
      }               
    }
    if (arrUsu.length !== 0 ) {
     
     setTimeout(() => {
      llamaApiCargaToken(dataInfo, auxU,respuesta,ErrorGeneral,setEspera,history,source);
     }, 500); 
    }                 
  }

/*   const obtnUsu=()=>{
    let auxCambio =[], auxCambio2 =[], auxCambio3 =[] 
    let nvArrCam=[]
    listTotUsu.forEach((element)=>{
      if (element.nom===usuarios.estacion1) {
        if (element.tp0 !== usuarios.tp0Est1) {
          auxCambio={...auxCambio, tp0:usuarios.tp0Est1 }
        }
        if (element.tp1 !== usuarios.tp1Est1) {
          auxCambio={...auxCambio, tp1:usuarios.tp1Est1 }
        }
        if (element.tp2 !== usuarios.tp2Est1) {
          auxCambio={...auxCambio, tp2:usuarios.tp2Est1 }
        }
        if (element.tp3 !== usuarios.tp3Est1) {
          auxCambio={...auxCambio, tp3:usuarios.tp3Est1 }
        }
        if (element.tp4 !== usuarios.tp4Est1) {
          auxCambio={...auxCambio, tp4:usuarios.tp4Est1 }
        }
        if (auxCambio.length!==0) {
          auxCambio={estacion:listTotUsu[0].estacion,...auxCambio}
        }
      }
      if (element.nom===usuarios.estacion2) {
        if (element.tp0 !== usuarios.tp0Est2) {
          auxCambio2={...auxCambio2, tp0:usuarios.tp0Est2 }
        }
        if (element.tp1 !== usuarios.tp1Est2) {
          auxCambio2={...auxCambio2, tp1:usuarios.tp1Est2 }
        }
        if (element.tp2 !== usuarios.tp2Est2) {
          auxCambio2={...auxCambio2, tp2:usuarios.tp2Est2 }
        }
        if (element.tp3 !== usuarios.tp3Est2) {
          auxCambio2={...auxCambio2, tp3:usuarios.tp3Est2 }
        }
        if (element.tp4 !== usuarios.tp4Est2) {
          auxCambio2={...auxCambio2, tp4:usuarios.tp4Est2 }
        }
        if (auxCambio2.length!==0) {
          auxCambio2={estacion:listTotUsu[1].estacion,...auxCambio2}
        }
      }
      if (element.nom===usuarios.estacion3) {
        if (element.tp0 !== usuarios.tp0Est3) {
          auxCambio3={...auxCambio3, tp0:usuarios.tp0Est3 }
        }
        if (element.tp1 !== usuarios.tp1Est3) {
          auxCambio3={...auxCambio3, tp1:usuarios.tp1Est3 }
        }
        if (element.tp2 !== usuarios.tp2Est3) {
          auxCambio3={...auxCambio3, tp2:usuarios.tp2Est3 }
        }
        if (element.tp3 !== usuarios.tp3Est3) {
          auxCambio3={...auxCambio3, tp3:usuarios.tp3Est3 }
        }
        if (element.tp4 !== usuarios.tp4Est3) {
          auxCambio3={...auxCambio3, tp4:usuarios.tp4Est3 }
        }
        if (auxCambio3.length!==0) {
          auxCambio3={estacion:listTotUsu[2].estacion,...auxCambio3}
        }
      }
    })
    
    if (auxCambio.length!==0) {
      nvArrCam.push(auxCambio)
    }
    if (auxCambio2.length!==0) {
      nvArrCam.push(auxCambio2)
    }
    if (auxCambio3.length!==0) {
      nvArrCam.push(auxCambio3)
    }
    return nvArrCam
  } */

  const obtnUsu2=()=>{
    let nvoArrCam=[]
    listTotUsu.forEach((element)=>{
      const indice= element.estacion
      let auxCambio=[]
      if (element.nom===usuarios[`estacion${indice}`]) {
        if (element.tp0 !== usuarios[`tp0Est${indice}`]) {
          auxCambio={  tp0:usuarios[`tp0Est${indice}`] }
        }
        if (element.tp1 !== usuarios[`tp1Est${indice}`]) {
          auxCambio={...auxCambio, tp1:usuarios[`tp1Est${indice}`] }
        }
        if (element.tp2 !== usuarios[`tp2Est${indice}`]) {
          auxCambio={...auxCambio, tp2:usuarios[`tp2Est${indice}`] }
        }
        if (element.tp3 !== usuarios[`tp3Est${indice}`]) {
          auxCambio={...auxCambio, tp3:usuarios[`tp3Est${indice}`] }
        }
        if (element.tp4 !== usuarios[`tp4Est${indice}`]) {
          auxCambio={...auxCambio, tp4:usuarios[`tp4Est${indice}`] }
        }
        if (auxCambio.length!==0) {
          auxCambio={estacion:indice,...auxCambio}
          nvoArrCam.push(auxCambio)
        }
      }
      //console.log(auxCambio);
      
    })
    return nvoArrCam
  }
 

  const onChangeNum = e =>
  { let expNopermitida = new RegExp('[#A-Za-z_:$!%-({})/*=?|]');
    let expMenos = new RegExp('-');
    let expMas = new RegExp('[+]');     
    let expCadena = new RegExp('[0-9]');
    if (expCadena.test(e.target.value)&&!expNopermitida.test(e.target.value)&&!expMenos.test(e.target.value)&&
        !expMas.test(e.target.value)||e.target.value===' '||e.target.value==='') 
    {
      setCostos({ ...costos, [e.target.name] : e.target.value })
      if (aviso) 
      {
        setMensaje('');
        setAviso(false);
      }
    }
  };

    const onChange2 = e =>
    { let expNopermitida = new RegExp('[#_:$!%-({})/*=?|]');
      let expMenos = new RegExp('-');
      let expMas = new RegExp('[+]');     
      let expCadena = new RegExp('[A-Za-z0-9]');
      if (expCadena.test(e.target.value)&&!expNopermitida.test(e.target.value)&&!expMenos.test(e.target.value)&&
          !expMas.test(e.target.value)||e.target.value===' '||e.target.value==='') 
      {
        setCostos({ ...costos, [e.target.name] : e.target.value })
        if (aviso) 
        {
          setMensaje('');
          setAviso(false);
        }
      }
    };
   
    const mostrarAlertas =(auxMensaje)=>{
      setTipoAdvertencia("warning")
      let mensaje=auxMensaje            
      setMensaje(mensaje);
      setAviso(true)   
    }

  function valNulos(auxMensaje,auxCampo) 
  { let valida=false    
    if ( auxCampo !== '' && auxCampo !== '0' && auxCampo !==0 
        && auxCampo !== null && auxCampo!==" " ) 
    {   valida=true              
    }
    if (!valida) 
    {   mostrarAlertas(auxMensaje)
    }
    return valida
  }
  
  function valNumero(auxNumero,auxCampo) {
    let valida=false    
    if (typeof parseInt(auxNumero) === 'number') 
    {
      if (parseInt(auxNumero) ==0) 
      {
        valida=true
      }  
      else{
        if (parseInt(auxNumero) >0) 
        {  
          valida=true
        } 
      }
    }
    if (!valida) {
      setTipoAdvertencia("warning")
      let mensaje="Llenar campo "+auxCampo            
      setMensaje(mensaje);
      setAviso(true)  
    }
    return valida
  }

  function valNumero2(auxNumero,auxCampo, minimo) {
    let valida=false    
    if (typeof parseInt(auxNumero) === 'number') 
    {
      if (parseInt(auxNumero) ==minimo) 
      {
        valida=true
      }  
      else{
        if (parseInt(auxNumero) >minimo) 
        {  
          valida=true
        } 
      }
    }
    if (!valida) {
      setTipoAdvertencia("warning")
      const mensaje=`Llenar campo ${auxCampo}, valor minimo ${minimo}.00`            
      setMensaje(mensaje);
      setAviso(true)  
    }
    return valida
  }
  
  const guardarDatos = () => 
  {      
    const fec = moment(finicio).format("YYYY-MM-DD");                                      
      // registrarCierre(fec.format("HH:mm"))    
      const arrUsu= obtnUsu2()         
      //console.log(arrUsu);
      
     if (valListUsu2() && valNumero2(CostoUser,"Precio General", 9) && 
      valNumero2(CostoEstu,"Precio Estudiante", 9) && valNumero(Estudiante,"Estudiantes")&& 
      valNumero(TrnsEstudiante,"Transbordos de Estudiantes" ) && valNumero(TrnsLrLv,"Transbordos LR-LV") && 
      valNumero(TrnsBusOp1,'Transbordos Mexibus L4 a Mexicable E-1 "Indio Verdes"' ) && 
      valNumero(TrnsBusOp2, 'Transbordos Mexibus L4 a Mexicable E-3 "Periférico"') &&
      valNumero(Tarjeta,"Consumo de Tarjetas" ) && valNumero(Sanitario,"Accesos a Sanitarios") ) 
    {
      if (arrUsu.length!==0) {
        setEditUsu(arrUsu) 
        registrarCierre(fec)    
      }
      else{
        registrarCierre(fec)    
      }           
    }                                                 
  };

  const onChangeInp = (e )=>
  { let expNopermitida = new RegExp('[#A-Za-z_:$!%-({})/*=?|]');
    let expMenos = new RegExp('-');
    let expMas = new RegExp('[+]');     
    let expCadena = new RegExp('[0-9]');
    if (expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) && !expMenos.test(e.target.value) 
      && !expMas.test(e.target.value) || e.target.value===' '|| e.target.value==='') 
    {
      
      setUsuarios({...usuarios,[e.target.name] : e.target.value   })        
    }
  };

function Row() {
  
  return (  
  <TableRow className={classes.row}>        
    <TableCell component="th" scope="row" align="center" style={{ fontWeight:700,width:80+'px'}} padding={'none'}  >
     Total
    </TableCell>                
    <TableCell align="center" padding={'none'} style={{ width:50+'px'}}  >
      {totUsu.tp0Tot}
    </TableCell>
    <TableCell align="center" padding={'none'} style={{ width:50+'px'}}>
      {totUsu.tp1Tot}
    </TableCell>      
    <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
      {totUsu.tp2Tot}
    </TableCell>  
    <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
      {totUsu.tp3Tot}
    </TableCell>  
    <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
      {totUsu.tp4Tot}
    </TableCell>   
  </TableRow>          
  );
  }

  //No se pueden iterar porque al momento de hacer el cambio refresca la tabla y pierde el foco
/*   const Renglon =({indice})=>{
    return(
    <TableRow className={classes.row}>        
      <TableCell component="th" scope="row" align="center" style={{ fontWeight:700,width:80+'px'}} padding={'none'}  >
        {usuarios[`estacion${indice}`]}
      </TableCell>                
      <TableCell align="center" padding={'none'} style={{ width:75+'px'}}  >
        <input type="text" id={`input-tp0Est${indice}`} value={usuarios[`tp0Est${indice}`]} name={`tp0Est${indice}`}
          onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700}}
          maxlength={limitNumber}  />      
      </TableCell>
   
    </TableRow> 
    )
  } */

  function tablaCompleta(auxlista){
    //console.log("entrando sin preguntar");
    const renglones =[ {Id:5},{Id:6},{Id:7}]
    return(
    <TableContainer className={classes.tablaContainer} id="tablaCompleta-paro" style={{width:"30rem"}}>
    <Table stickyHeader aria-label="sticky table">
      <TableHead>
        <TableRow  >          
          <TableCell style={{ color:colorFuente}} align="center" padding={'none'} >Estación</TableCell>          
          <TableCell style={{ color:colorFuente}} align="center" padding={'none'} >
           {/*  <img src='user_cobro2.svg' height={23} width={23}/> 
            <br/> */} Cobro</TableCell>
          <TableCell style={{ color:colorFuente}} align="center" padding={'none'} >
         {/*  <img src='abuelo.svg' height={23} width={23}/> 
          <br/>  */}3era Edad</TableCell>
          <TableCell style={{ color:colorFuente}} align="center" padding={'none'} >
          {/* <img src='silla_ruedas.svg' height={23} width={23}/> 
          <br/> */}Disca...</TableCell>
          <TableCell style={{ color:colorFuente}} align="center" padding={'none'} >
         {/*  <img src='nino.png' height={23} width={23}/> 
          <br/> */}Niños</TableCell>
          <TableCell style={{ color:colorFuente}} align="center" padding={'none'} >
         {/*  <img src='otro.png' height={23} width={23}/> 
          <br/> */}Otro</TableCell>
          
        </TableRow>
      </TableHead>
      <TableBody>      
        <TableRow className={classes.row}>        
          <TableCell component="th" scope="row" align="center" style={{ fontWeight:700,width:80+'px'}} padding={'none'}  >
            {usuarios[`estacion${1}`]}
          </TableCell>                
          <TableCell align="center" padding={'none'} style={{ width:75+'px'}}  >
            <input type="text" id={`input-tp0Est1`} value={usuarios[`tp0Est1`]} name={`tp0Est1`} 
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              maxlength={limitNumber}   />   
              
          </TableCell>
          <TableCell align="center" padding={'none'} style={{ width:75+'px'}}>
            <input type="text" id={`input-tp1Est1`} value={usuarios[`tp1Est1`]} name={`tp1Est1`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}  
              maxlength={limitNumber}  />      
          </TableCell>      
          <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
            <input type="text" id={`input-tp2Est1`} value={usuarios[`tp2Est1`]} name={`tp2Est1`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}} 
              maxlength={limitNumber}  />      
          </TableCell>  
          <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
            <input type="text" id={`input-tp3Est1`} value={usuarios[`tp3Est1`]} name={`tp3Est1`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}  
              maxlength={limitNumber}  />      
          </TableCell>  
          <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
            <input type="text" id={`input-tp4Est1`} value={usuarios[`tp4Est1`]} name={`tp4Est1`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              maxlength={limitNumber}  />      
          </TableCell>  
        </TableRow> 
        <TableRow className={classes.row}>        
          <TableCell component="th" scope="row" align="center" style={{ fontWeight:700,width:80+'px'}} padding={'none'}  >
            {usuarios[`estacion${2}`]}
          </TableCell>                
          <TableCell align="center" padding={'none'} style={{ width:75+'px'}}  >
            <input type="text" id={`input-tp0Est2`} value={usuarios[`tp0Est2`]} name={`tp0Est2`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              maxlength={limitNumber}  />      
          </TableCell>
          <TableCell align="center" padding={'none'} style={{ width:75+'px'}}>
            <input type="text" id={`input-tp1Est2`} value={usuarios[`tp1Est2`]} name={`tp1Est2`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              maxlength={limitNumber}  />      
          </TableCell>      
          <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
            <input type="text" id={`input-tp2Est2`} value={usuarios[`tp2Est2`]} name={`tp2Est2`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              maxlength={limitNumber}  />      
          </TableCell>  
          <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
            <input type="text" id={`input-tp3Est2`} value={usuarios[`tp3Est2`]} name={`tp3Est2`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              maxlength={limitNumber}  />      
          </TableCell>  
          <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
            <input type="text" id={`input-tp4Est2`} value={usuarios[`tp4Est2`]} name={`tp4Est2`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              maxlength={limitNumber}  />      
          </TableCell>  
        </TableRow>
        <TableRow className={classes.row}>        
          <TableCell component="th" scope="row" align="center" style={{ fontWeight:700,width:80+'px'}} padding={'none'}  >
            {usuarios[`estacion${3}`]}
          </TableCell>                
          <TableCell align="center" padding={'none'} style={{ width:75+'px'}}  >
            <input type="text" id={`input-tp0Est3`} value={usuarios[`tp0Est3`]} name={`tp0Est3`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              maxlength={limitNumber}  />      
          </TableCell>
          <TableCell align="center" padding={'none'} style={{ width:75+'px'}}>
            <input type="text" id={`input-tp1Est3`} value={usuarios[`tp1Est3`]} name={`tp1Est3`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              maxlength={limitNumber}  />      
          </TableCell>      
          <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
            <input type="text" id={`input-tp2Est3`} value={usuarios[`tp2Est3`]} name={`tp2Est3`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              maxlength={limitNumber}  />      
          </TableCell>  
          <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
            <input type="text" id={`input-tp3Est3`} value={usuarios[`tp3Est3`]} name={`tp3Est3`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              maxlength={limitNumber}  />      
          </TableCell>  
          <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
            <input type="text" id={`input-tp4Est3`} value={usuarios[`tp4Est3`]} name={`tp4Est3`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              maxlength={limitNumber}  />      
          </TableCell>  
        </TableRow>       
        <TableRow className={classes.row}>        
          <TableCell component="th" scope="row" align="center" style={{ fontWeight:700,width:80+'px'}} padding={'none'}  >
            {usuarios[`estacion${4}`]}
          </TableCell>                
          <TableCell align="center" padding={'none'} style={{ width:75+'px'}}  >
            <input type="text" id={`input-tp0Est4`} value={usuarios[`tp0Est4`]} name={`tp0Est4`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              maxlength={limitNumber}  />      
          </TableCell>
          <TableCell align="center" padding={'none'} style={{ width:75+'px'}}>
            <input type="text" id={`input-tp1Est4`} value={usuarios[`tp1Est4`]} name={`tp1Est4`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              maxlength={limitNumber}  />      
          </TableCell>      
          <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
            <input type="text" id={`input-tp2Est4`} value={usuarios[`tp2Est4`]} name={`tp2Est4`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              maxlength={limitNumber}  />      
          </TableCell>  
          <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
            <input type="text" id={`input-tp3Est4`} value={usuarios[`tp3Est4`]} name={`tp3Est4`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              maxlength={limitNumber}  />      
          </TableCell>  
          <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
            <input type="text" id={`input-tp4Est4`} value={usuarios[`tp4Est4`]} name={`tp4Est4`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              maxlength={limitNumber}  />      
          </TableCell>  
        </TableRow>   
        <TableRow className={classes.row}>        
          <TableCell component="th" scope="row" align="center" style={{ fontWeight:700,width:80+'px'}} padding={'none'}  >
            {usuarios[`estacion${5}`]}
          </TableCell>                
          <TableCell align="center" padding={'none'} style={{ width:75+'px'}}  >
            <input type="text" id={`input-tp0Est${5}`} value={usuarios[`tp0Est${5}`]} name={`tp0Est${5}`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              maxlength={limitNumber}  />      
          </TableCell>
          <TableCell align="center" padding={'none'} style={{ width:75+'px'}}>
            <input type="text" id={`input-tp1Est${5}`} value={usuarios[`tp1Est${5}`]} name={`tp1Est${5}`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              maxlength={limitNumber}  />      
          </TableCell>      
          <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
            <input type="text" id={`input-tp2Est${5}`} value={usuarios[`tp2Est${5}`]} name={`tp2Est${5}`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              maxlength={limitNumber}  />      
          </TableCell>  
          <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
            <input type="text" id={`input-tp3Est${5}`} value={usuarios[`tp3Est${5}`]} name={`tp3Est${5}`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              maxlength={limitNumber}  />      
          </TableCell>  
          <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
            <input type="text" id={`input-tp4Est${5}`} value={usuarios[`tp4Est${5}`]} name={`tp4Est${5}`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              maxlength={limitNumber}  />      
          </TableCell>  
        </TableRow>     
        <TableRow className={classes.row}>        
          <TableCell component="th" scope="row" align="center" style={{ fontWeight:700,width:80+'px'}} padding={'none'}  >
            {usuarios[`estacion${6}`]}
          </TableCell>                
          <TableCell align="center" padding={'none'} style={{ width:75+'px'}}  >
            <input type="text" id={`input-tp0Est${6}`} value={usuarios[`tp0Est${6}`]} name={`tp0Est${6}`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              maxlength={limitNumber}  />      
          </TableCell>
          <TableCell align="center" padding={'none'} style={{ width:75+'px'}}>
            <input type="text" id={`input-tp1Est${6}`} value={usuarios[`tp1Est${6}`]} name={`tp1Est${6}`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              maxlength={limitNumber}  />      
          </TableCell>      
          <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
            <input type="text" id={`input-tp2Est${6}`} value={usuarios[`tp2Est${6}`]} name={`tp2Est${6}`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              maxlength={limitNumber}  />      
          </TableCell>  
          <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
            <input type="text" id={`input-tp3Est${6}`} value={usuarios[`tp3Est${6}`]} name={`tp3Est${6}`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              maxlength={limitNumber}  />      
          </TableCell>  
          <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
            <input type="text" id={`input-tp4Est${6}`} value={usuarios[`tp4Est${6}`]} name={`tp4Est${6}`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              maxlength={limitNumber}  />      
          </TableCell>  
        </TableRow>  
        <TableRow className={classes.row}>        
          <TableCell component="th" scope="row" align="center" style={{ fontWeight:700,width:80+'px'}} padding={'none'}  >
            {usuarios[`estacion${7}`]}
          </TableCell>                
          <TableCell align="center" padding={'none'} style={{ width:75+'px'}}  >
            <input type="text" id={`input-tp0Est${7}`} value={usuarios[`tp0Est${7}`]} name={`tp0Est${7}`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              maxlength={limitNumber}  />      
          </TableCell>
          <TableCell align="center" padding={'none'} style={{ width:75+'px'}}>
            <input type="text" id={`input-tp1Est${7}`} value={usuarios[`tp1Est${7}`]} name={`tp1Est${7}`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              maxlength={limitNumber}  />      
          </TableCell>      
          <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
            <input type="text" id={`input-tp2Est${7}`} value={usuarios[`tp2Est${7}`]} name={`tp2Est${7}`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              maxlength={limitNumber}  />      
          </TableCell>  
          <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
            <input type="text" id={`input-tp3Est${7}`} value={usuarios[`tp3Est${7}`]} name={`tp3Est${7}`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              maxlength={limitNumber}  />      
          </TableCell>  
          <TableCell align="center" padding={'none'} style={{width: 75 + 'px'}}>
            <input type="text" id={`input-tp4Est${7}`} value={usuarios[`tp4Est${7}`]} name={`tp4Est${7}`}
              onChange={onChangeInp}  style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              maxlength={limitNumber}  />      
          </TableCell>  
        </TableRow>            
        {totUsu.length!==0 ? <Row/> : null }        
      </TableBody>
    </Table>
    </TableContainer>
   )
  }

  return ( 
  <Modal
    titulo={titulo} modalAbierto={modalAbierto}
    setModalAbierto={setModalAbierto} guardarDatos={guardarDatos}
    mensaje={mensaje} tipoAdvertencia={tipoAdvertencia} tamanio="sm"
    aviso={aviso} setAviso={setAviso} espera={espera} btnDesact={false}
  >
    <form className={classes.root} noValidate autoComplete="off" fullWidth>                    
      <Box display={"flex"}  flexDirection={"column"}>
      <Box display={"flex"}  style={{width:"30rem"}} mb={1}>
        {usuarios.length !== 0 ? tablaCompleta(usuarios) : null}
      </Box>
      <Box display={"flex"} flexDirection={"column"} mt={1}>
        <Box display={"flex"} flexDirection={"row"}  >
          <Box display="flex" flexDirection="row"  style={{width:"15rem", paddingTop:.3+'rem'}}>                  
            <input type="text" id="input-CostoUser" style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              value={CostoUser} onChange={onChangeNum} name="CostoUser" />
            <span style={{paddingLeft:'.5rem',width:"15rem", color:colorFuente,fontWeight:600}}>
              Precio General
            </span>   
          </Box>
          <Box display="flex" flexDirection="row"  style={{width:"15rem", paddingTop:.3+'rem'}}>                  
            <input type="text" id="input-CostoEstu" style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
              value={CostoEstu} onChange={onChangeNum} name="CostoEstu" />
            <span style={{paddingLeft:'.5rem',width:anchoTxtLbl, color:colorFuente,fontWeight:600}}>
              Precio Estudiante
            </span>   
          </Box>
         
        </Box>
       
        <Box display="flex" flexDirection="row"  style={{width:anchoLabel, paddingTop:.3+'rem'}}>                  
          <input type="text" id="input-Estudiante" style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
            value={Estudiante} onChange={onChangeNum} name="Estudiante" />
          <span style={{paddingLeft:'.5rem',width:anchoTxtLbl, color:colorFuente,fontWeight:600}}>
            Estudiantes
          </span>   
        </Box>
        <Box display="flex" flexDirection="row"  style={{width:anchoLabel, paddingTop:.3+'rem'}}>                  
          <input type="text" id="input-TrnsEstudiante" style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
            value={TrnsEstudiante} onChange={onChangeNum} name="TrnsEstudiante" />
          <span style={{paddingLeft:'.5rem',width:anchoTxtLbl, color:colorFuente,fontWeight:600}}>
            Transbordos de Estudiantes
          </span>   
        </Box>
        <Box display="flex" flexDirection="row"  style={{width:anchoLabel, paddingTop:.3+'rem'}}>                  
          <input type="text" id="input-TrnsLrLv" style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
            value={TrnsLrLv} onChange={onChangeNum} name="TrnsLrLv" />
          <span style={{paddingLeft:'.5rem',width:anchoTxtLbl, color:colorFuente,fontWeight:600}}>
            Transbordos LR-LV
          </span>   
        </Box>
        <Box display="flex" flexDirection="row"  style={{width:anchoLabel, paddingTop:.3+'rem'}}>                  
          <input type="text" id="input-TrnsBusOp1" style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
            value={TrnsBusOp1} onChange={onChangeNum} name="TrnsBusOp1" />
          <span style={{paddingLeft:'.5rem',width:anchoTxtLbl, color:colorFuente,fontWeight:600}}>
            Transbordos Mexibus L4 a Mexicable E-1 "Indio Verdes"
          </span>   
        </Box>
        <Box display="flex" flexDirection="row"  style={{width:anchoLabel, paddingTop:.3+'rem'}}>                  
          <input type="text" id="input-TrnsBusOp2" style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
            value={TrnsBusOp2} onChange={onChangeNum} name="TrnsBusOp2" />
          <span style={{paddingLeft:'.5rem',width:anchoTxtLbl, color:colorFuente,fontWeight:600}}>
            Transbordos Mexibus L4 a Mexicable E-3 "Periférico"
          </span>   
        </Box>
        <Box display="flex" flexDirection="row"  style={{width:anchoLabel, paddingTop:.3+'rem'}}>                  
          <input type="text" id="input-Tarjeta" style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
            value={Tarjeta} onChange={onChangeNum} name="Tarjeta" />
          <span style={{paddingLeft:'.5rem',width:anchoTxtLbl, color:colorFuente,fontWeight:600}}>
            Consumo de Tarjetas
          </span>   
        </Box>
        <Box display="flex" flexDirection="row"  style={{width:anchoLabel, paddingTop:.3+'rem'}}>                  
          <input type="text" id="input-Sanitario" style={{width:4+'rem',height:1.5+'rem',fontWeight:700, textAlign:"right"}}
            value={Sanitario} onChange={onChangeNum} name="Sanitario" />
          <span style={{paddingLeft:'.5rem',width:anchoTxtLbl, color:colorFuente,fontWeight:600}}>
            Accesos a Sanitarios
          </span>   
        </Box>
        
      </Box>
      </Box>    
    </form>
  </Modal>
  );
}
 
export default ModalCapturaUsuarios;